import { capture } from '../../services/sentry/capture';
import { GraphQLError } from 'graphql';
import toast from 'react-hot-toast';

export const updatePanierCallback = (
  produit,
  setState,
  initialState,
  callback = null
) => {
  return {
    onCompleted: () => {
      toast.success(
        'Le produit : ' + produit.name + ' a été ajouté au panier avec succès'
      );
      setState({
        ...initialState
      });
      callback && setTimeout(() => callback(), 1000);
    },
    onError: err => {
      toast.error("Erreur dans l'ajout au panier");
      setState({
        ...initialState
      });
      capture(new GraphQLError(err));
    }
  };
};
